import { SELLER_PORTAL_DOWNGRADE_LIST } from '@/_constants';

export const cleanupList = () => {
  try {
    localStorage.removeItem(SELLER_PORTAL_DOWNGRADE_LIST);
    // eslint-disable-next-line no-empty
  } catch {}
};
